import { render } from "./PageGuide.vue?vue&type=template&id=e369d518&scoped=true&ts=true"
import script from "./PageGuide.vue?vue&type=script&lang=ts"
export * from "./PageGuide.vue?vue&type=script&lang=ts"

import "./PageGuide.vue?vue&type=style&index=0&id=e369d518&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e369d518"]])

export default __exports__